<template>
  <v-container>
      <v-card>
        <v-card-title>
            <h3>Tutoriais</h3>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text>
            <v-row>
                <v-col cols="6" v-for="tutorial in tutoriais" :key="tutorial.index">
                    <v-card width="100%">
                        <v-card-title class="subtitle-1">
                            {{ tutorial.title }}
                        </v-card-title>
                        <v-divider></v-divider>
                        <v-card-text>
                            <iframe width="100%" height="300" :src="tutorial.urlVideo" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
                        </v-card-text>
                    </v-card>
                </v-col>
            </v-row>
        </v-card-text>
      </v-card>
  </v-container>
</template>

<script>
export default {
    name: 'Tutoriais',
    data: () => ({
        tutoriais: [
            { title: 'Acessando o sistema', urlVideo: 'https://www.youtube.com/embed/wtVNKUCKQDo'},
            { title: 'Configurando as formas de trabalho', urlVideo: 'https://www.youtube.com/embed/__ruqUrMC9w'},
            { title: 'Agendamento do atendimento externo', urlVideo: 'https://www.youtube.com/embed/i-jYFpJnEHg'},
            { title: 'Certificação e realização dos serviços', urlVideo: 'https://www.youtube.com/embed/ZSHtGYnCeHw'},
            { title: 'Registrando os participantes(CPF)', urlVideo: 'https://www.youtube.com/embed/Zd6V3pEz3VQ'},
            { title: 'Autorizar contar na produção do credenciado', urlVideo: 'https://www.youtube.com/embed/pr2mH6YWfsQ'},
            { title: 'Autorizar contabilizar na estatística', urlVideo: 'https://www.youtube.com/embed/M7dUwYf5U-Q'},
            { title: 'Autorizar envio para o faturamento', urlVideo: 'https://www.youtube.com/embed/dmzn-L7J6XM'},
            { title: 'Consultando e acompanhando a execução dos contratos', urlVideo: 'https://www.youtube.com/embed/Pp9dpLyRxg4'}
        ]
    })
}
</script>

<style>

</style>